import React from 'react';
import './MovingTexts.css';
import Marquee from 'react-fast-marquee';

const MovingText = ({ newsItems }) => {
  return (
    <div className='flex  flex-nowrap py-2 '>
      <Marquee direction='left' speed={50}>
        <div className='flex gap-4 justify-center items-center px-4'>
          {newsItems?.map((news, index) => (
            <div
              key={index}
              className='text-md text-white flex justify-center items-center '
            >
              {news}
              {newsItems.length > 1 && <span className='ml-2'> | </span>}
            </div>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

export default MovingText;
